// extracted by mini-css-extract-plugin
export default {"container":"styles_container__XquEw","description":"styles_description__7zLpo","form":"styles_form__LsIB1","item":"styles_item__ZDCEQ","label":"styles_label__JLicw"};